document.addEventListener("DOMContentLoaded", function() {
     document.querySelectorAll('.quickbuyMobile').forEach(button => {
        button.addEventListener('click', event => {
            const productUrl = button.dataset.productUrl;
            console.log(productUrl);

            fetch(`${productUrl}?view=ajax`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.text();
                })
                .then(htmlContent => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(htmlContent, 'text/html');
                    console.log(doc);

                    const productImage = button.closest('.m-product-card').querySelector('.m-product-card__main-image responsive-image');
                    const productTitle = doc.querySelector('.m-product-title');
                    const productPrice = doc.querySelector('.m-price-item--regular');

                    if (!productImage || !productTitle || !productPrice) {
                        console.error('Product image, title, or price not found');
                        return;
                    }

                    const pickerContainer = document.querySelector('.picker-modal');
                    const pickerImage = pickerContainer.querySelector('.picker-image');
                    const pickerTitle = pickerContainer.querySelector('.picker-summary-title');
                    const pickerPrice = pickerContainer.querySelector('.picker-image-summary-price');

                    if (!pickerImage || !pickerTitle || !pickerPrice) {
                        console.error('Picker image, title, or price elements not found in the picker container');
                        return;
                    }

                    pickerImage.innerHTML = productImage.innerHTML;
                    pickerTitle.textContent = productTitle.textContent;
                    pickerPrice.textContent = productPrice.textContent;

                    const variantSelectors = document.querySelector('.variant-selctors');
                    const productVariantSelectors = doc.querySelector('.m-main-product--info');

                    variantSelectors.innerHTML = productVariantSelectors.innerHTML;
                    reorderColorSwatchesFromUrl(); // reorderColorSwatches
                    const soldOutOptions = document.querySelectorAll('.variant-selctors .m-product-option--node.m-product-option--node__soldout');
                    
                    const modalCloseBtn = document.querySelector('.modal-close-btn-picker');
                    const modalOverlay = document.querySelector('.modal-overlay');
                    const pickerModal = document.querySelector('.picker-modal');
                    
                   
                    
                    const variantColorComponent = document.querySelector('.variant-selctors [data-option-name="Color"]');
                    console.log(variantColorComponent);

                    const checkedRadioButton = variantColorComponent.querySelector('input[type="radio"]:checked');
                    console.log(checkedRadioButton.value);

                   if (checkedRadioButton) {
    variantColorComponent.setAttribute('data-selected-value', checkedRadioButton.value);
    const selectedSpan = variantColorComponent.querySelector('.option-label--selected');
    console.log(selectedSpan);
    if (selectedSpan) {
        selectedSpan.innerHTML = checkedRadioButton.value;
        // console.log(selectedSpan.innerHTML);
    }
}
                   const quickBuyText = document.querySelector('.qb-txt');
                   quickBuyText.textContent= 'quick buy';
                   const closebtnSvg = document.querySelector('.modal-close-btn-picker');
                  closebtnSvg.innerHTML = ' <svg height="16px" width="16px" viewBox="0 0 10 10" class="BaseIcon-sc-8v47i9-0 bPleON"><g stroke="currentColor" stroke-width="1.5"><path class="p1" d="M8.695 1.095l-7.6 7.6" stroke-width="1.5"></path><path class="p2" d="M8.695 8.695l-7.6-7.6" stroke-width="1.5"></path></g></svg>'
                    
                    

                    modalOverlay.style.position = 'fixed';
                    modalOverlay.style.inset = '0px';
                    modalOverlay.style.background = 'rgba(0, 0, 0, 0.5)';
                    pickerModal.classList.add('open');
                    pickerModal.style.position = 'absolute';
                    pickerModal.style.inset = 'auto 0px 0px';
                    pickerModal.style.border = '0px solid rgb(204, 204, 204)';
                    pickerModal.style.background = 'white';
                    pickerModal.style.borderRadius = '0px';
                    pickerModal.style.outline = 'none';
                    pickerModal.style.padding = '0px';
                    pickerModal.style.maxHeight = '75%';

                    modalCloseBtn.addEventListener('click', function() {
                        pickerModal.classList.remove('open');
                        pickerModal.style.maxHeight = '0';
                        setTimeout(function() {
                            modalOverlay.style.position = '';
                            modalOverlay.style.inset = '';
                            modalOverlay.style.background = '';
                        }, 400);
                    });

                    const addToCartPopUp = document.querySelector('.variant-selctors button[type="submit"]');
                    addToCartPopUp.addEventListener('click', function() {
                        pickerModal.classList.remove('open');
                        setTimeout(function() {
                            modalOverlay.style.position = '';
                            modalOverlay.style.inset = '';
                            modalOverlay.style.background = '';
                        }, 400);
                    });

                    function addSvgToChecked(e) {
                        document.querySelectorAll('.variant-selctors .asdf label svg').forEach(function(svg) {
                            svg.remove();
                        });

                        let checkedInput = document.querySelector('.variant-selctors .asdf input[type="radio"]:checked');
                        if (checkedInput) {
                            let inputValue = e.value;
                            console.log(inputValue);
                            let svgColor = inputValue === 'White' ? 'black' : 'white';
                            console.log(svgColor);

                            let labelElement = checkedInput.closest('label') || checkedInput.nextElementSibling;

                            let svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                            svgElement.setAttribute('height', '18px');
                            svgElement.setAttribute('width', '18px');
                            svgElement.setAttribute('viewBox', '-5 -7 20 20');

                            let pathElement = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                            pathElement.setAttribute('d', 'M0.375713 3.18538L1.22425 2.33687L3.84263 4.95531L8.77571 0.0222307L9.62424 0.870759L3.84262 6.65238L0.375713 3.18538Z');
                            pathElement.setAttribute('fill', svgColor);

                            svgElement.appendChild(pathElement);

                            if (labelElement) {
                                labelElement.appendChild(svgElement);
                            }
                        }
                    }

                    document.querySelectorAll('.variant-selctors .asdf input[type="radio"]').forEach(function(radio) {
                        radio.addEventListener('change', function() {
                            addSvgToChecked(this);
                        });
                    });

                    addSvgToChecked(document.querySelector('.variant-selctors .asdf input[type="radio"]:checked'));

                    const newProductUrl = productUrl.split('?')[0];
                    console.log(newProductUrl);

                    const colorVariantInputs = document.querySelectorAll('.variant-selctors input[name="Color"]');
                    colorVariantInputs.forEach(input => {
                        input.addEventListener('click', function() {
                            const selectedVariantColor = this.value;
                            fetch(newProductUrl + ".js")
                                .then(response => {
                                    if (response.ok) {
                                        return response.json();
                                    }
                                    throw new Error('Network response was not ok.');
                                })
                                .then(productJson => {
                                    const colorPickerVariant = productJson.variants.find(e => e.title.includes(selectedVariantColor));
                                    const imgSrc = colorPickerVariant.featured_media.preview_image.src;
                                    const mainImage = this.closest('.picker-modal').querySelector('.picker-image img');
                                    mainImage.src = `${imgSrc}&width=533`;
                                    mainImage.removeAttribute("srcset");
                                    mainImage.alt = selectedVariantColor;
                                });
                        });
                    });
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        });
    });

});
